import { sendRequest } from "../config";

/**
 * 获取结算币种
 */
export const getSettlementCurrency = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/getSettlementCurrency"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 虚拟账户申请资格查询
 */
export const checkVaPermission = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/checkVaPermission"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};

/**
 * 申请创建分发账户
 */
export const applyCreateCurrentz = param => {
	return sendRequest(["POST", "/merchant/acquirer/currents/add"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 申请创建虚拟账户1
 */
export const applyCreateVa = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/applyCreateVa"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 申请创建虚拟账户2 - 上送关联结果
 */
export const createVirtualAccount = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/createVirtualAccount"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 获取虚拟账户列表
 */
export const getVaList = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/getVaList"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 新增虚拟账户币种
 */
export const addVaCurrency = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/addVaCurrency"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};

/**
 * 查询是否已关联va账户和currents账户
 * @param {*} param 
 * @returns 
 */
export const queryRelateAccounts = () => {
	return sendRequest(["POST", "/merchant/acquirer/bizinfo/queryRelateAccounts"]);
};


/**
 * 获取免密登陆链接
 */
 export const getAutoLoginAddress = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/getAutoLoginAddress"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};

/**
 * 获取Currents免密登陆链接
 */
 export const getAutoLoginCurrentsAddress = param => {
	return sendRequest(["POST", "/merchant/acquirer/currents/getAutoLoginAddress"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 【4.21】获取提现账户列表
 */
export const getAccountList = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiary/getAccountList"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};

/**
 * 【【4.21】银行卡详情
 */
export const getAccountDetail = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiary/getAccountDetail"], param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};


/**
 * 【4.21】银行卡修改
 */
export const accountModify = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiary/update"], param);
};

/**
 * 【4.21】银行卡删除
 */
export const deleteAccount = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiary/delete"], param)
};

/**
 * 查询当前商户已保存的公司章程文件
 */
export const getAssociation = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/getAssociation"], param)
};


/**
 * 上传公司章程
 */
export const uploadAssociation = param => {
	return sendRequest(["POST", "/merchant/acquirer/beneficiaryVa/uploadAssociation"], param)
};


/**
 * 自动提现 - 查询自动提现列表
 */
export const fetchAwdList = data => {
	return sendRequest(["POST", "/merchant/acquirer/autoWithdrawConfig/query"], data)
};

/**
 * 自动提现 - 获取周期枚举
 */
export const fetchaAwdConfig = () => {
	return sendRequest(["GET", "/merchant/acquirer/autoWithdrawConfig/getEnum"])
};

/**
 * 自动提现 - 保存配置
 */
export const fetchaAwdSave = (data) => {
	return sendRequest(["POST", "/merchant/acquirer/autoWithdrawConfig/save"], data)
};

/**
 * 自动提现 - 关闭自动提现功能
 */
export const closeAwd = () => {
	return sendRequest(["POST", "/merchant/acquirer/autoWithdrawConfig/close"])
};


